import React, { useState, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const DEFAULT_HERO_IMAGE = "https://customer-assets.emergentagent.com/job_finition-sousa/artifacts/s7axzr25_0A6E20AF-9E26-4502-B9CA-202AAFA696DA.jpg";

const HeroSection = () => {
  const [content, setContent] = useState(null);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await fetch(`${API_URL}/api/content`);
        if (response.ok) {
          setContent(await response.json());
        }
      } catch (error) {
        console.error('Error fetching content:', error);
      }
    };
    fetchContent();
  }, []);

  const tagline = content?.tagline || "Déjà 60 ans que nous bâtissons notre relation, nous consolidons votre confiance";
  const heroImage = content?.hero_image || DEFAULT_HERO_IMAGE;

  const scrollToNext = () => {
    const element = document.getElementById('histoire');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center overflow-hidden"
    >
      {/* Background Image - no overlay to see the stone */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${heroImage})` }}
      />

      {/* Content - split far left and far right, positioned at 25% */}
      <div className="absolute top-[25%] -translate-y-1/2 left-0 right-0 z-10 flex items-start justify-between px-6 md:px-12 lg:px-20">
        {/* Left side - Company name */}
        <div className="text-left">
          <p className="text-stone-900 text-xs md:text-sm tracking-[0.3em] uppercase mb-2 font-medium drop-shadow-[0_1px_2px_rgba(255,255,255,0.8)]">
            Depuis 1965
          </p>
          <h1 className="font-serif text-2xl md:text-3xl lg:text-4xl font-semibold tracking-wide text-stone-900 leading-tight drop-shadow-[0_1px_2px_rgba(255,255,255,0.8)]">
            DÉCORATION<br />DE SOUSA<br />FRÈRES
          </h1>
        </div>

        {/* Right side - Tagline */}
        <div className="text-center max-w-[200px] md:max-w-[240px]">
          <p className="text-stone-900 text-base md:text-lg font-medium leading-relaxed drop-shadow-[0_1px_2px_rgba(255,255,255,0.8)]">
            {tagline}
          </p>
        </div>
      </div>

      {/* Scroll Indicator */}
      <button
        onClick={scrollToNext}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 text-stone-800 hover:text-stone-600 transition-colors animate-bounce"
      >
        <ChevronDown size={32} />
      </button>
    </section>
  );
};

export default HeroSection;
